import React, { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { Typography, TableCell, TableRow, Grid, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddEditDependentMutation from "./AddEditDependentMutation/AddEditDependentMutation";

import { MutationStatusRef } from "../../../models/mutation-statuses/mutation-status-ref";
import { EmployeeDependentMutationSTO } from "../../../models/employee-dependents/mutations/employee-dependent-mutation-sto";

import { EmployeeDataContext } from "../EmployeeDataAndMutaions";

import { intlFormatDateShort } from "../../../utils/time-utils";
import { MUTATIONS_STATUSES } from "../../../utils/constants/constants";

import { DependentProps } from "./interfaces";
import { DependentContainer, StyledTableCell, Label } from "./styles";

const EmployeeDependent = ({ dependent, mutation, handleReload }: DependentProps) => {
  const theme = useTheme();
  const { employee } = useContext(EmployeeDataContext);

  const newEmployeeDependentMutation = {
    isDeleted: false,
    id: uuidv4(),
    companyAccount: employee?.companyAccount,
    legalEntity: employee?.legalEntity,
    employee,
    original: dependent,
    firstName: dependent.firstName,
    lastName: dependent.lastName,
    birthDate: dependent.birthDate,
    dependentType: dependent.dependentType,
    status: {
      id: MUTATIONS_STATUSES.PENDING.id,
    } as MutationStatusRef,
    toDate: dependent.toDate,
  } as EmployeeDependentMutationSTO;

  return (
    <>
      <StyledTableCell>
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          {`${dependent?.dependentType?.name}`}
          <AddEditDependentMutation
            original={dependent}
            mutation={mutation ?? newEmployeeDependentMutation}
            hasMutation={!!mutation}
            handleReload={handleReload}
          />
        </Grid>
      </StyledTableCell>
      <TableCell
        // rowSpan={6}
        style={{ verticalAlign: "top", padding: 0 }}
      >
        <Divider
          flexItem
          orientation="horizontal"
          style={{
            width: "100%",
            minWidth: "10px",
            marginTop: "20px",
            border: `3px solid ${theme.palette.background.paper}`,
          }}
        />
      </TableCell>
      <StyledTableCell>
        <Typography>
          {`${dependent?.firstName} ${dependent?.lastName}
        ${dependent?.birthDate && intlFormatDateShort(dependent.birthDate)}`}
        </Typography>
      </StyledTableCell>
    </>
  );
};

export default EmployeeDependent;
